<app-odata-typeahead-search
  [label]="label"
  [controlId]="controlId"
  [odataFunction]="odataFunction"
  [placeHolder]="placeHolder"
  i18n-placeHolder
  [disabled]="disabled || !!selectedMember"
  [searchedProperties]="searchedProperties"
  [customItemTemplate]="lookAheadItemTemplate"
  popperClass="look-ahead-popper-full-width"
  [hasErrors]="hasErrors"
  (lookAheadSelected)="onMemberSelected($event)" />

<ng-template #lookAheadItemTemplate let-member>{{ member.name }} ({{ member.id }})</ng-template>
